<template>
  <div class="modal">
    <b-modal
      :ref="refId"
      :id="refId"
      hide-footer
      no-close-on-esc
      hide-header
      no-close-on-backdrop
      size="xl"
    >
      <div class="d-flex justify-content-between">
        <div>
          <span class="font-weight-bold fs-16">Fnb Categories</span>
        </div>
        <div class="cross_icon" @click.prevent.stop="$bvModal.hide(refId)">
          X
        </div>
      </div>

      <!-- <div
        v-if="isFnbDataLoading && fnbMoreCategoriesItem"
        class="pos-fnb-item-not-found"
      >
        <div>
          <div>
            <img src="@/assets/img/icons/loading.svg" height="75" width="75" />
          </div>
          <h6 class="pt-3 mb-2">Loading...</h6>
          <h6>Fetching Fnb Categories...Please Wait</h6>
        </div>
      </div> -->

      <div v-if="fnbMoreCategoriesItem == 0" class="pos-fnb-item-not-found">
        <div>
          <div>
            <img
              src="@/assets/img/icons/pos-fnb-no-itmes.svg"
              height="75"
              width="75"
            />
          </div>
          <h6 class="pt-3 mb-2">Opps!</h6>
          <h6>No Categories Found!</h6>
        </div>
      </div>
      <div class="row p-2 justify-content-center" style="gap:17px" v-else>
        <!-- style="gap:10px" -->
        <div
          v-for="(fnbCategory, fnbCategoryIndex) in fnbMoreCategoriesItem"
          :key="fnbCategoryIndex + 'foods'"
          class="col-2 card_category p-1"
        >
          <button
            @click.prevent.stop="
              $bvModal.hide(refId);
              setOnFnBPayloads({
                event: $event,
                name: 'category',
                fc_id: fnbCategory.fc_id,
              });
            "
            class=""
            style="border:none"
            :class="[
              'btn-pos-menu ',
              { active: category == fnbCategory.fc_id },
            ]"
          >
            <div class="svg-container">
              <img
                :src="
                  fnbCategory.fc_icon_active_url
                    ? _GetImagePath(fnbCategory.fc_icon_active_url)
                    : fnbCategory.fc_icon_url
                "
                height="auto"
                width="40"
              />
              <!---alt="fnbCategory.fc_category"-->
            </div>
            <span class="word_break">{{ fnbCategory.fc_category }} </span>
          </button>
        </div>
      </div>
    </b-modal>
    <h4>Test Modal</h4>
  </div>
</template>
<script>
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    name: "CategoryPopup",
    props: {
      refId: {
        type: String,
        default: "categorymodal",
      },
    },
    data() {
      return {
        category: null
      };
    },

    computed: {
      ...mapGetters([
        "fnbCategories",
        "fnbMoreCategories",

        // "MultiFnbFlag"
      ]),
      fnbMoreCategoriesItem() {
        let fnbItemNew =
          this.fnbCategories && this.fnbCategories.length
            ? _.orderBy(this.fnbCategories, "fc_category")
            : [];
        return fnbItemNew;
      },
    },
    beforeMount() {},
    methods: {
      ...mapActions([
        "onSwtichModule",
        "onResetOffersAndPrice",
        "fetchFnBItems",
        "setOnFnBPayloads",
        "onResetFnBHandler",
        "onOrderSubmit",
        "GET_PAYMENT_MODES",
        "HARD_RELOAD_POS",
        //
        "GoToRoute",
        //
        // "SelectedFnbItemList",
      ]),
      closeModal() {
        let setFnbItemsClick = this.setOnFnBPayloads
          ? this.$bvModal.hide(refId)
          : this.$bvModal.show(refId);
        return setFnbItemsClick;
      },
      close() {
        this.$bvModal.hide(refId);
      },
    },
  };
</script>

<style scoped>
  .cross_icon {
    display: flex;
    justify-content: end;
    font-size: 18px;
    font-weight: bold;
    cursor: pointer;
  }
  .card_category {
    border-radius: 8px;
    border: none;
    width: 100%;

    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  }
  .word_break {
    word-break: break-all;
  }
</style>



// WEBPACK FOOTER //
// src/components/Partials/PosFnbCategoryPopup.vue